import React, { useContext, useEffect, useState } from "react";
import { Offcanvas, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../context/UserContextProvider";
import APIServicenew from "../../utils/APIGeneralService";
import { capitalizeFirstLetter } from "../../utils/Helper";

function GradeFilter({ appliedFilters, show, onHide, onApplyFilter, onClear }) {
  const [filters, setFilters] = useState({
    search: appliedFilters?.search || "",
    status: appliedFilters?.status || "",
  });

  const [filterOptions, setFilterOptions] = useState({
    statuses: [
      { id: "Active", name: "Active" },
      { id: "Inactive", name: "Inactive" }
    ]
  });
  
  const APIServices = new APIServicenew(process.env.REACT_APP_OTHER_API_URL);
  const authToken = process.env.REACT_APP_authToken;
  const { accessToken, logout } = useContext(UserContext);
  const headers = { 
    "Content-Type": "application/json",
    "auth-token": authToken, 
    "authorization": accessToken 
  };
  const navigate = useNavigate();


  const handleFilterChange = (event) => {
    const { name, value } = event.target;
    setFilters({ ...filters, [name]: value });
  };

  const handleClearAll = () => {
    setFilters({
      name: "",
      code: "",
      status: "",
    });
    if (onClear) {
      onClear();
    }
  };

  const handleApply = () => {
    // Remove empty values before applying
    const cleanedFilters = {};
    Object.keys(filters).forEach(key => {
      if (filters[key] && filters[key].trim && filters[key].trim() !== "") {
        cleanedFilters[key] = filters[key].trim();
      } else if (filters[key] && filters[key] !== "") {
        cleanedFilters[key] = filters[key];
      }
    });
    
    if (onApplyFilter) {
      onApplyFilter(cleanedFilters);
    }
  };

  const isFilterApplied = () => {
    return filters.search  || filters.status;
  };

  return (
    <Offcanvas
      className="mom_filter"
      show={show}
      onHide={onHide}
      placement="end"
      backdrop="static"
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title className="font_blue_18 font-600">
          Filter Grades
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="pt-0">
        <Form className="filter_form">
          <div className="mb-3">
            <label className="font_blue_14 font-500 mb-2">
              Grade Name
            </label>
            <Form.Control
              type="text"
              placeholder="Enter grade name"
              name="search"
              value={filters.search}
              onChange={handleFilterChange}
              autoComplete="off"
            />
          </div>
          <div className="mb-3">
            <label className="font_blue_14 font-500 mb-2">Status</label>
            <Form.Select
              name="status"
              value={filters.status}
              onChange={handleFilterChange}
            >
              <option value="">All Status</option>
              {filterOptions.statuses.map((status) => (
                <option key={status.id} value={status.id}>
                  {status.name}
                </option>
              ))}
            </Form.Select>
          </div>
        </Form>
        
        <div className="offcanvas-footer mt-4 d-flex gap-2">
          
          <button 
            className="btn blue_border flex-grow-1" 
            onClick={handleClearAll}
          >
            Clear All
          </button>
          <button
            className="btn red_button flex-grow-1"
            onClick={handleApply}
          >
            Apply
          </button>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default GradeFilter;